import { render, staticRenderFns } from "./banking-thank-you.vue?vue&type=template&id=4dc74860&scoped=true&lang=pug&"
import script from "./banking-thank-you.vue?vue&type=script&lang=js&"
export * from "./banking-thank-you.vue?vue&type=script&lang=js&"
import style0 from "./banking-thank-you.vue?vue&type=style&index=0&id=4dc74860&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc74860",
  null
  
)

/* custom blocks */
import block0 from "./banking-thank-you.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {WidgetsImage: require('/home/ubuntu/nuxt/bonkers/releases/20231205171632/components/widgets/image.vue').default,WidgetsLottie: require('/home/ubuntu/nuxt/bonkers/releases/20231205171632/components/widgets/lottie.vue').default,WidgetsProgress: require('/home/ubuntu/nuxt/bonkers/releases/20231205171632/components/widgets/progress.vue').default})
